import { render, staticRenderFns } from "./projectApp.vue?vue&type=template&id=4d18a914&scoped=true"
import script from "./projectApp.vue?vue&type=script&lang=js"
export * from "./projectApp.vue?vue&type=script&lang=js"
import style0 from "./projectApp.vue?vue&type=style&index=0&id=4d18a914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18a914",
  null
  
)

export default component.exports